<div class="field field-text">
  @if (label) {
    <span class="label">{{label}} @if (optionalString) {
      <span>({{optionalString}})</span>
    }</span>
  }
  <input
    [class.error-field]="error"
    type="text"
    [(ngModel)]="localModel"
    (blur)="onBlur($event)"
    (keyup.enter)="onBlur(); enter.emit()"
    [placeholder]="placeholder"
    />
  @if (error) {
    <span class="error-field-display">{{error}}</span>
  }
</div>